<template>
  <div class="policy-page">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol lg="10" md="12">
          <div class="back-button-container">
            <CButton color="primary" variant="outline" @click="goBack">
              Back to Dashboard
            </CButton>
          </div>
          <CCard class="policy-card">
            <CCardBody>
              <h1 class="policy-title">Cookies Policy</h1>
              
              <div class="policy-content">
                <p class="last-updated">Last Updated: {{ lastUpdated }}</p>
                
                <p>At <strong>Scienlabs Technologies</strong>, we value your privacy and are committed to being transparent about the technologies we use. This Cookies Policy explains what cookies are, how we use them, and how you can manage your preferences when visiting our website.</p>
                
                <h2>1. What Are Cookies?</h2>
                
                <p>Cookies are small text files placed on your device when you visit a website. They help websites recognize your device, remember your preferences, and improve your browsing experience.</p>
                
                <h2>2. How We Use Cookies</h2>
                
                <p>We use cookies for the following purposes:</p>
                
                <div class="cookie-type">
                  <h3>Essential Cookies</h3>
                  <p>Necessary for the basic functioning of our website. Without these, our site cannot operate properly.</p>
                </div>
                
                <div class="cookie-type">
                  <h3>Performance & Analytics Cookies</h3>
                  <p>Help us understand how visitors use our site, measure performance, and improve user experience.</p>
                </div>
                
                <div class="cookie-type">
                  <h3>Functional Cookies</h3>
                  <p>Allow us to remember your preferences (e.g., language or region) to provide a more personalized experience.</p>
                </div>
                
                <div class="cookie-type">
                  <h3>Marketing & Advertising Cookies</h3>
                  <p>Used to deliver relevant content and measure the effectiveness of campaigns.</p>
                </div>
                
                <h2>3. Third-Party Cookies</h2>
                
                <p>Some cookies are placed by trusted third-party providers (e.g., analytics and advertising partners) to help us better understand user behavior and provide tailored content.</p>
                
                <h2>4. How You Can Control Cookies</h2>
                
                <p>You have full control over your cookie preferences:</p>
                
                <ul>
                  <li>You can manage or disable cookies at any time through our <a href="#" @click.prevent="openCookieSettings">Cookie Preferences Tool</a>.</li>
                  <li>Most web browsers also allow you to block or delete cookies via their settings.</li>
                  <li>Please note that disabling certain cookies may affect the functionality and performance of our website.</li>
                </ul>
                
                <h2>5. Data Protection & Privacy</h2>
                
                <p>Any personal data collected through cookies is handled in accordance with our <router-link to="/pages/privacy-policy">Privacy Policy</router-link> and applicable data protection laws, including the GDPR.</p>
                
                <h2>6. Updates to This Policy</h2>
                
                <p>We may update this Cookies Policy from time to time to reflect changes in technology, law, or our practices. The "Last Updated" date at the top will indicate the most recent revision.</p>
                
                <h2>7. Contact Us</h2>
                
                <p>If you have any questions about how we use cookies, please contact our DPO:</p>
                
                <div class="contact-box">
                  <h3>Data Protection Officer (DPO)</h3>
                  <p>
                    <strong>Name:</strong> Nadeem Kazi<br>
                    <strong>Email:</strong> <a href="mailto:dpo@scienlabs.com">dpo@scienlabs.com</a>
                  </p>
                </div>
                
                <div class="cookie-settings-button">
                  <CButton color="primary" size="lg" @click="openCookieSettings">
                    <CIcon name="cil-settings" /> Manage Cookie Preferences
                  </CButton>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'CookiePolicy',
  data() {
    return {
      lastUpdated: new Date('2025-08-25').toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    }
  },
  methods: {
    openCookieSettings() {
      this.$store.dispatch('openCookiePreferences')
    },
    goBack() {
      this.$router.push('/dashboard')
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
.policy-page {
  min-height: 100vh;
  padding: 2rem 0;
  background: #f0f3f5;
}

.back-button-container {
  margin-bottom: 1rem;
}

.policy-card {
  margin-bottom: 2rem;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
}

.policy-title {
  color: #2f353a;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  border-bottom: 2px solid #e4e7ea;
  padding-bottom: 1rem;
}

.last-updated {
  text-align: center;
  color: #73818f;
  font-style: italic;
  margin-bottom: 2rem;
}

.policy-content {
  color: #5c6873;
  line-height: 1.8;
  font-size: 1.05rem;
}

.policy-content h2 {
  color: #2f353a;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 1.8rem;
  border-bottom: 1px solid #e4e7ea;
  padding-bottom: 0.5rem;
}

.policy-content h3 {
  color: #2f353a;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
}

.policy-content ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.policy-content li {
  margin-bottom: 0.8rem;
}

.policy-content strong {
  color: #2f353a;
}

.cookie-type {
  background: #f8f9fa;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 0.25rem;
  border-left: 3px solid #321fdb;
}

.cookie-type h3 {
  margin-top: 0;
  color: #321fdb;
}

.cookie-type p {
  margin-bottom: 0;
}

.contact-box {
  background: #f8f9fa;
  border-left: 4px solid #321fdb;
  padding: 1.5rem;
  margin: 2rem 0;
  border-radius: 0.25rem;
}

.contact-box h3 {
  margin-top: 0;
  color: #321fdb;
}

.contact-box p {
  margin-bottom: 0;
}

.cookie-settings-button {
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e4e7ea;
}

@media (max-width: 768px) {
  .policy-title {
    font-size: 2rem;
  }
  
  .policy-content {
    font-size: 1rem;
  }
  
  .policy-content h2 {
    font-size: 1.5rem;
  }
  
  .policy-content h3 {
    font-size: 1.1rem;
  }
}
</style>